import React from 'react'
import './Packages.css'

const Packages = () => {
  return (
    <div class='wrapper'>
      <h2 class="primary mb packages__title">Our Packages </h2>
      <br/>
      <div className='package__cont'>
        
        <div class='package'>
          <div class='name'>Full Package: (Training program and progression tracking+meal plan)</div>
          <div class='trial'>Online coaching services include:</div>
          <hr/>
          <ul>
            <li>Customized training program all the details included.</li>
            <li>Daily macros.</li>
            <li>Food library (calories and macros for most consumed foods).</li>
            <li>Customer care 24/7 over WhatsApp.</li>
            <li>Anything that bothers you could be immediately changed.</li>
            <li>Lifestyle supervision and guidance for optimal recovery and performance.</li>
            <li>Exercise library .</li>
            <li>MEAL PLAN customized with the food of your preference while hitting the required macros.</li>
            <li>Includes up to 3 Options/Meal.</li>
            <li>Weekly follow ups+check ins.</li>
          </ul>
        </div>
        
        <div class='package'>
          <div class='name'>Individualized training plan</div>
          <div class='trial'>One time purchase plan (8 weeks)
          </div>

          <hr/>

          <ul>
            <li>Customized training program all the details included.</li>
            <li>Anything that bothers you could be immediately changed.</li>
          </ul>
        </div>
        
        <div class='package'>
          <div class='name'>1 month meal plan
           </div>
           <div class='trial'>Nutrition guidance
            </div>

          {/* Individualized training plan-1 time purchase */}
          <hr/>
          <ul>
            <li>Includes up to 3 Options/Meal.</li>
            <li>Detailed with all the Macros&Calories for each meal.</li>
            <li>Food servings per grams.</li>
            <li>Weekly follow ups + check ins.
            </li>
          </ul>
        </div>
      </div>
   
    </div>
  )
}

export default Packages
